"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionUpgradeIndicator = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const design_system_1 = require("@hashintel/design-system");
const material_1 = require("@mui/material");
const VersionUpgradeIndicator = ({ currentVersion, latestVersion, onUpdateVersion, }) => {
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", gap: 1, alignItems: "center", children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "smallTextLabels", color: "gray.50", fontWeight: 500, children: ["v", currentVersion] }), (0, jsx_runtime_1.jsx)(design_system_1.IconArrowRight, { sx: { color: ({ palette }) => palette.gray[50], fontSize: 14 } }), (0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "smallTextLabels", color: "blue.70", fontWeight: 500, children: ["v", latestVersion] }), (0, jsx_runtime_1.jsxs)(design_system_1.IconButton, { onClick: onUpdateVersion, sx: {
                    p: 0.5,
                    minWidth: 0,
                    minHeight: 0,
                    fontSize: 11,
                    fontWeight: 700,
                    color: ({ palette }) => palette.blue[70],
                    textTransform: "uppercase",
                    gap: 0.625,
                    lineHeight: "18px",
                    ":hover": {
                        color: ({ palette }) => palette.blue[70],
                        [`.${material_1.svgIconClasses.root}`]: {
                            transform: "rotate(360deg)",
                            transition: ({ transitions }) => transitions.create("transform"),
                        },
                    },
                }, children: [(0, jsx_runtime_1.jsx)(design_system_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faArrowsRotate, sx: {
                            fontSize: 11,
                        } }), "Update"] })] }));
};
exports.VersionUpgradeIndicator = VersionUpgradeIndicator;
